import React from "react";

type Props = {
  title: string;
  /** Plain string for simple cases; ReactNode supports inline
   *  formatting like spans / code / icons. */
  description?: React.ReactNode;
  actions?: React.ReactNode;
  breadcrumbs?: { label: string; to?: string }[];
};

export default function PageHeader({ title, description, actions }: Props): React.ReactElement {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-text-primary truncate">
          {title}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-text-secondary leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
